module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-bar"
  }, [(_vm.canShowName || _vm.withoutLabel.length > 0 || _vm.withLabel.length > 0 || _vm.showConsent() || _vm.showPwdSection) ? _c('div', [(_vm.canShowName || _vm.withoutLabel.length > 0) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap",
    class: {
      'cb-bar__wrap--readonly': !(_vm.canEditName || _vm.canEditEmailPhone)
    },
    attrs: {
      "role": "navigation",
      "aria-describedby": "edit_text",
      "data-cb-id": "portal_account_detail"
    },
    on: {
      "click": function($event) {
        _vm.accountEvent()
      }
    }
  }, [_c('div', {
    staticClass: "cb-content"
  }, [(_vm.canShowName) ? _c('div', {
    staticClass: "cb-content__title"
  }, [_vm._v("\n          " + _vm._s(_vm.name()) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.withoutLabel), function(fieldName, index) {
    return (_vm.withoutLabel) ? _c('div', {
      key: index,
      staticClass: "cb-content__text"
    }, [_vm._v("\n          " + _vm._s(fieldName) + "\n        ")]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showConsent()) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap",
    attrs: {
      "aria-describedby": "edit_text",
      "data-cb-id": "portal_consent_detail"
    },
    on: {
      "click": function($event) {
        _vm.navigate('portal_consent_details')
      }
    }
  }, [_c('div', {
    staticClass: "cb-content"
  }, [_c('div', {
    staticClass: "cb-content__title"
  }, [_vm._v("\n          " + _vm._s(_vm.t('consent_section.name')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cb-content__text"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showPwdSection) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap",
    attrs: {
      "aria-describedby": "edit_text",
      "data-cb-id": "portal_password_detail"
    },
    on: {
      "click": function($event) {
        _vm.navigatePwd()
      }
    }
  }, [_c('div', {
    staticClass: "cb-content"
  }, [_c('div', {
    staticClass: "cb-content__title"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordSectionName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cb-content__text"
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.withLabel), function(fieldName, index) {
    return (_vm.withLabel.length > 0) ? _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-bar__wrap",
      class: {
        'cb-bar__wrap--readonly': !_vm.canEdit(fieldName)
      },
      attrs: {
        "role": "navigation",
        "aria-describedby": "edit_text",
        "data-cb-id": "portal_account_detail"
      },
      on: {
        "click": function($event) {
          _vm.canEdit(fieldName) && _vm.navigate('portal_edit_account', {
            params: {
              field: fieldName
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "cb-content"
    }, [(_vm.name) ? _c('div', {
      staticClass: "cb-content__title"
    }, [_vm._v("\n          " + _vm._s(_vm.getLabel(fieldName)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getValue(fieldName)) ? _c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.sanitizeBrTags(_vm.getValue(fieldName))),
        expression: "sanitizeBrTags(getValue(fieldName))"
      }],
      staticClass: "cb-content__text"
    }) : _c('div', [_vm._v("\n          -\n        ")])])]) : _vm._e()
  })], 2) : _c('div', [_c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap",
    attrs: {
      "role": "navigation",
      "aria-describedby": "edit_text",
      "data-cb-id": "portal_account_detail"
    },
    on: {
      "click": function($event) {
        _vm.accountEvent()
      }
    }
  }, [_vm._v("\n      Click to Edit Account details\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "no-display",
    attrs: {
      "aria-hidden": "true",
      "id": "edit_text"
    }
  }, [_vm._v(_vm._s(_vm.st('account_edit')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-051b3e3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalAccountSummary.vue
// module id = 575
// module chunks = 66